import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import ActivitiesTable from "@/components/ListTable/ActivitiesTable";
import { LAZY_TABLE_FULL_PAGE_GUTTER } from "@/constants/Layout";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { ListProvider } from "@/modules/list";

const TABLE_VH_DIFF = LAZY_TABLE_FULL_PAGE_GUTTER;

const Activities = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:activities")} />
      <AppLayoutPage>
        <ListProvider
          endpoint="activities"
          storageKey={STORAGE_KEYS.ACTIVITIES}
          defaultSort={["-created_at"]}
          hiddenFilters={{ "filter[batch_uuid]": "null" }}
          lazy={{ scrollY: { vhDiff: TABLE_VH_DIFF } }}
          pageSize={15}
        >
          <ActivitiesTable />
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Activities;
